import React, { useState, useEffect } from 'react';
import BaseLayout from './BaseLayout';
import axios from 'axios';
import { API_BASE } from '../api';
import { useAuth } from "../context/AuthContext";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';

const rowStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '20px',
  flexWrap: 'wrap',
};

const buttonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  margin: '0 10px',
  padding: '40px 5px',
  fontSize: '1.8rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: '1px solid #ccc',
  borderRadius: '4px',
  backgroundColor: '#f0f0f0',
  outline: 'none',
  transition: 'background-color 0.3s',
  minWidth: '100px',
  maxWidth: '200px',
  flex: '1 1 auto',
};

const drawButtonStyle = {
  ...buttonStyle,
  padding: '10px 20px',
  fontSize: '1rem',
  margin: '5px auto 0',
  width: '80px',
  height: '40px',
};

const selectedButtonStyle = {
  ...buttonStyle,
  borderColor: '#007bff',
  backgroundColor: '#007bff',
  color: '#ffffff',
};

const sportButtonStyle = {
  ...buttonStyle,
  padding: '10px',
  fontSize: '1.5rem',
  width: 'auto',
  margin: '0 5px',
};

const selectedSportButtonStyle = {
  ...selectedButtonStyle,
  padding: '10px',
  fontSize: '1.5rem',
};

const selectedDrawButtonStyle = {
  ...drawButtonStyle,
  borderColor: '#007bff',
  backgroundColor: '#007bff',
  color: '#ffffff',
};

const makePicksButtonStyle = {
  padding: '20px 40px',
  fontSize: '1.5rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: '#28a745',
  color: '#ffffff',
  margin: '30px auto 1px',
  display: 'block',
  outline: 'none',
  transition: 'background-color 0.3s',
};

/*const skipButtonStyle = {
  padding: '10px 20px',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: '1px solid #ccc',
  borderRadius: '5px',
  backgroundColor: '#ffffff',
  color: '#000000',
  marginLeft: '10px',
  outline: 'none',
  transition: 'opacity 0.3s',
};*/

// Explicit mapping from full database name (lowercase) to short display name
const TEAM_NAME_MAP = {
  // NBA
  'philadelphia 76ers':        '76ers',
  'portland trail blazers':    'Blazers',
  'milwaukee bucks':           'Bucks',
  'chicago bulls':             'Bulls',
  'cleveland cavaliers':       'Cavaliers',
  'boston celtics':            'Celtics',
  'los angeles clippers':      'Clippers',
  'memphis grizzlies':         'Grizzlies',
  'atlanta hawks':             'Hawks',
  'miami heat':                'Heat',
  'charlotte hornets':         'Hornets',
  'sacramento kings':          'Kings',
  'new york knicks':           'Knicks',
  'los angeles lakers':        'Lakers',
  'dallas mavericks':          'Mavericks',
  'brooklyn nets':             'Nets',
  'denver nuggets':            'Nuggets',
  'indiana pacers':            'Pacers',
  'new orleans pelicans':      'Pelicans',
  'detroit pistons':           'Pistons',
  'toronto raptors':           'Raptors',
  'houston rockets':           'Rockets',
  'san antonio spurs':         'Spurs',
  'phoenix suns':              'Suns',
  'oklahoma city thunder':     'Thunder',
  'minnesota timberwolves':    'Timberwolves',
  'golden state warriors':     'Warriors',
  'washington wizards':        'Wizards',
  // EPL
  'arsenal':                   'Arsenal',
  'aston villa':                'Aston Villa',
  'bournemouth':               'Bournemouth',
  'brentford':                 'Brentford',
  'brighton and hove albion':  'Brighton',
  'burnley':                   'Burnley',
  'chelsea':                   'Chelsea',
  'crystal palace':            'Crystal Palace',
  'everton':                   'Everton',
  'fulham':                    'Fulham',
  'leeds united':              'Leeds',
  'liverpool':                 'Liverpool',
  'manchester city':           'Manchester City',
  'manchester united':         'Manchester United',
  'newcastle united':          'Newcastle',
  'nottingham forest':         'Nottingham Forest',
  'tottenham hotspur':         'Tottenham',
  'west ham united':           'West Ham',
  'wolverhampton wanderers':   'Wolves',
  'sunderland':                'Sunderland',
  // MLS
  'atlanta united':            'Atlanta',
  'austin fc':                 'Austin',
  'charlotte fc':              'Charlotte',
  'chicago fire':              'Chicago',
  'fc cincinnati':             'Cincinnati',
  'colorado rapids':           'Colorado',
  'columbus crew':             'Columbus',
  'fc dallas':                 'Dallas',
  'dc united':                 'DC United',
  'houston dynamo':            'Houston',
  'sporting kansas city':      'Kansas City',
  'la galaxy':               'L.A. Galaxy',
  'los angeles fc':            'Los Angeles',
  'inter miami':               'Miami',
  'minnesota united':          'Minnesota',
  'cf montréal':               'Montreal',
  'nashville sc':              'Nashville',
  'new england revolution':    'New England',
  'new york city fc':          'New York City',
  'new york red bulls':        'New York',
  'orlando city':              'Orlando',
  'philadelphia union':        'Philadelphia',
  'portland timbers':          'Portland',
  'real salt lake':            'Salt Lake',
  'san diego fc':              'San Diego',
  'san jose earthquakes':      'San Jose',
  'seattle sounders':          'Seattle',
  'st. louis city sc':         'St. Louis',
  'toronto fc':                'Toronto',
  'vancouver whitecaps':       'Vancouver',
  // MLB
  'los angeles angels':        'Angels',
  'houston astros':            'Astros',
  'athletics':                 'Athletics',
  'toronto blue jays':         'Blue Jays',
  'atlanta braves':            'Braves',
  'milwaukee brewers':         'Brewers',
  'st. louis cardinals':       'Cardinals',
  'chicago cubs':              'Cubs',
  'arizona diamondbacks':      'Diamondbacks',
  'los angeles dodgers':       'Dodgers',
  'san francisco giants':      'Giants',
  'cleveland guardians':       'Guardians',
  'seattle mariners':          'Mariners',
  'miami marlins':             'Marlins',
  'new york mets':             'Mets',
  'washington nationals':      'Nationals',
  'baltimore orioles':         'Orioles',
  'san diego padres':          'Padres',
  'philadelphia phillies':     'Phillies',
  'pittsburgh pirates':        'Pirates',
  'texas rangers':             'Rangers',
  'tampa bay rays':            'Rays',
  'boston red sox':            'Red Sox',
  'cincinnati reds':           'Reds',
  'colorado rockies':          'Rockies',
  'kansas city royals':        'Royals',
  'detroit tigers':            'Tigers',
  'minnesota twins':           'Twins',
  'chicago white sox':         'White Sox',
  'new york yankees':          'Yankees',
};

const getTeamDisplayName = (fullName) => {
  const lower = fullName.toLowerCase().trim();
  if (TEAM_NAME_MAP[lower]) return TEAM_NAME_MAP[lower];
  // Fallback: return the last word, capitalised
  const words = fullName.trim().split(/\s+/);
  const last = words[words.length - 1];
  return last.charAt(0).toUpperCase() + last.slice(1).toLowerCase();
};

const RecentUpdatesModal = ({ show, handleClose }) => {

  const classicUpdates = [
    { title: 'Notification Tab', description: 'There is now a notification tab indicated by a bell icon on the navigation bar. The notification tab will display messages from other users and incoming friend requests.' },
    { title: 'Friends', description: 'You are now able to friend other users. You can send a friend request by navigating to a user\'s profile and clicking the top right button. Friend Requests will appear in the notification box. As of now, there are no applications of the friend mechanic, but you will be able to sort tables by friends in a future update. This update will also implement unfriending/blocking.' },
    { title: 'Games Not Loading', description: 'There was an issue with recent games not loading to the site to be picked (thesportsdb slightly changed their html). A button has now been added to the home page to "Force Refresh". In other words, you can force a query for new games at any time. This option has also been added to update scores. A query may take up to a minute.' },
    { title: 'Plans for Next Update', description: 'Messages, Table sorting (friend-based and other), General performance enhancing and bug fixes. Send a support message for update requests and issue reports.' },
  ];

  const updates = classicUpdates;
  const modalTitle = '5/31/24 Updates';

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
          {updates.map((update, index) => (
            <li key={index} style={{ marginBottom: '10px' }}>
              <strong>{update.title}</strong>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#555' }}>{update.description}</p>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const MatchPick = ({ homeTeam, awayTeam, gameid, onPickSelected, isEPL, isLoading }) => {
  const [pick, setPick] = useState(null);

  // homeTeam/awayTeam are the full backend names (e.g. "DENVER NUGGETS").
  // homeDisplay/awayDisplay are the short UI labels (e.g. "Nuggets").
  const homeDisplay = getTeamDisplayName(homeTeam);
  const awayDisplay = getTeamDisplayName(awayTeam);

  const handlePick = (team) => {
    setPick(pick === team ? null : team);
    onPickSelected(pick === team ? null : team, gameid);
  };

  const versusStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 20px',
    fontWeight: 'bold',
    fontSize: '1rem',
  };

  const logoStyle = {
    height: '100px',
    width: 'auto',
    marginRight: '10px',
    marginLeft: '10px',
  };

  return (
    <div style={rowStyle}>
      <img src={`/Logos/${homeDisplay.charAt(0).toUpperCase() + homeDisplay.slice(1).toLowerCase()}.png`} alt={homeDisplay} style={logoStyle} />
      <button onClick={() => handlePick(homeTeam)} style={pick === homeTeam ? selectedButtonStyle : buttonStyle}>
        {homeDisplay}
      </button>
      <div style={{ ...versusStyle, flexDirection: 'column' }}>
        VS.
        {isEPL && !isLoading && (
          <button
            onClick={() => handlePick("Draw")}
            style={pick === "Draw" ? selectedDrawButtonStyle : drawButtonStyle}
          >
            DRAW
          </button>
        )}
      </div>
      <button onClick={() => handlePick(awayTeam)} style={pick === awayTeam ? selectedButtonStyle : buttonStyle}>
        {awayDisplay}
      </button>
      <img src={`/Logos/${awayDisplay.charAt(0).toUpperCase() + awayDisplay.slice(1).toLowerCase()}.png`} alt={awayDisplay} style={logoStyle} />
    </div>
  );
};

const HomePage = ({ isAuthenticated, user }) => {
  const { authData, updateUserAttribute } = useAuth();
  const [eventsByDate, setEventsByDate] = useState({});
  const [gameVisibility, setGameVisibility] = useState({});
  const [picks, setPicks] = useState({});
  const [loading, setLoading] = useState(true);
  const [submittingStatus, setSubmittingStatus] = useState({});
  const [selectedSport, setSelectedSport] = useState('NBA');
  const [allPicksMade, setAllPicksMade] = useState({
    NBA: false,
    EPL: false,
    MLB: false,
    MLS: false
  });
  const [showModal, setShowModal] = useState(false);
  const [pickFeedback, setPickFeedback] = useState({});  // { [date]: { type: 'success'|'error', msg: '' } }

  useEffect(() => {
    document.body.classList.add("account-page-bg");
    const fetchAndGroupEventsByDate = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error('No authentication token found');
          return;
        }
    
        const eventsPromise = axios.get(`${API_BASE}/data/get-upcoming-games`, { params: { sport: selectedSport } });
        const picksPromise = axios.get(`${API_BASE}/user/get-picks`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
    
        const [eventsResponse, picksResponse] = await Promise.all([eventsPromise, picksPromise]);
    
        const events = eventsResponse.data.games;
        const userPicks = new Set(picksResponse.data.map(pick => pick.game_id));
    
        const currentDate = new Date();
    
        const filteredAndGroupedEvents = events
          .filter(event => !userPicks.has(event.game_id))
          .reduce((acc, event) => {
            const [day, month, year] = event.date.split('/').map(Number);
            const eventYear = year || currentDate.getFullYear(); // Use current year if year is missing
            const timeParts = event.time.match(/(\d+):(\d+)(am|pm)/);
            let hour = Number(timeParts[1]);
            if (timeParts[3] === 'pm' && hour !== 12) hour += 12;
            if (timeParts[3] === 'am' && hour === 12) hour = 0;
            const gameDate = new Date(Date.UTC(eventYear, month - 1, day, hour));
            gameDate.setHours(gameDate.getHours() - 4); // Adjust for timezone
            const adjustedDate = `${gameDate.getDate().toString().padStart(2, '0')}/${(gameDate.getMonth() + 1).toString().padStart(2, '0')}/${gameDate.getFullYear()}`;
    
            acc[adjustedDate] = acc[adjustedDate] || [];
            acc[adjustedDate].push({
              ...event,
              adjustedDate
            });
            return acc;
          }, {});
    
        setEventsByDate(filteredAndGroupedEvents);
    
        const initialGameVisibility = Object.keys(filteredAndGroupedEvents).reduce((acc, date) => {
          acc[date] = filteredAndGroupedEvents[date].reduce((acc, game) => {
            acc[game.game_id] = true;
            return acc;
          }, {});
          return acc;
        }, {});
    
        setGameVisibility(initialGameVisibility);
    
      } catch (error) {
        console.error('Error fetching events or user picks:', error);
      }
      setLoading(false);
    };

    fetchAndGroupEventsByDate();
    return () => {
      document.body.classList.remove("account-page-bg");
    }
  }, [selectedSport]);

  useEffect(() => {
    //console.log("Last login: ", authData.user?.last_login)
    //console.log("User: ", authData.user)
    if (authData.user?.last_login) {
      const lastLogin = new Date(authData.user.last_login);
      const specifiedDate = new Date('2025-06-06');
      if (lastLogin < specifiedDate) {
        setShowModal(true);
        updateUserAttribute("last_login", null)
      }
    }
  }, [authData, updateUserAttribute]);

  const handleMakePicksForDate = async (date, sport) => {
    setSubmittingStatus(prev => ({ ...prev, [date]: true }));
    const token = localStorage.getItem("token");
    if (!token) {
      console.error('No authentication token found');
      setSubmittingStatus(prev => ({ ...prev, [date]: false }));
      return;
    }

    const datePicks = picks[date];
    if (!datePicks || datePicks.length === 0) {
      console.error('No picks to submit for this date:', date);
      setSubmittingStatus(prev => ({ ...prev, [date]: false }));
      return;
    }

    const postData = datePicks.map(pick => ({
      game_id: pick.gameid,
      sport: sport,
      picked_team: pick.team,
    }));

    try {
      await axios.post(`${API_BASE}/user/make-pick`, postData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      setPicks(prev => {
        const newPicks = { ...prev };
        delete newPicks[date];
        return newPicks;
      });
      setGameVisibility(prev => {
        const newVisibility = { ...prev };
        datePicks.forEach(pick => {
          if (newVisibility[date]) {
            newVisibility[date][pick.gameid] = false;
          }
        });
        updateAllPicksMade(selectedSport);
        return newVisibility;
      });
      setPickFeedback(prev => ({ ...prev, [date]: { type: 'success', msg: 'Picks submitted!' } }));
      setTimeout(() => setPickFeedback(prev => { const n = { ...prev }; delete n[date]; return n; }), 3000);
    } catch (error) {
      console.error('Error submitting picks:', error);
      setPickFeedback(prev => ({ ...prev, [date]: { type: 'error', msg: 'Failed to submit. Please try again.' } }));
      setTimeout(() => setPickFeedback(prev => { const n = { ...prev }; delete n[date]; return n; }), 4000);
    } finally {
      setSubmittingStatus(prev => ({ ...prev, [date]: false }));
    }
  };

  const formatDate = (dateString) => {
    const months = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    const [day, month, year] = dateString.split('/').map(Number);
    return `${months[month - 1]} ${day}, ${year}`;
  };

  const sortDates = (dates) => {
    return dates.sort((a, b) => {
      const [dayA, monthA, yearA] = a.split('/').map(Number);
      const [dayB, monthB, yearB] = b.split('/').map(Number);
      const dateA = new Date(Date.UTC(yearA, monthA - 1, dayA));
      const dateB = new Date(Date.UTC(yearB, monthB - 1, dayB));
      return dateA - dateB;
    });
  };

  const setSetSelectedSport = (sport) => {
    if (sport === selectedSport) return;
    setLoading(true);
    setSelectedSport(sport);
  }

  const updateAllPicksMade = (sport) => {
    const allDays = Object.keys(eventsByDate);
    let allPicked = allDays.every(day => {
      const gamesForDay = eventsByDate[day];
      return gamesForDay.every(game => !gameVisibility[day]?.[game.game_id]);
    });

    setAllPicksMade(prev => ({
      ...prev,
      [sport]: allPicked
    }));
  }

  return (
    <BaseLayout isAuthenticated={isAuthenticated} user={user}>
      <RecentUpdatesModal show={showModal} handleClose={() => setShowModal(false)} />
      <div className='homepage-container'>
        <h5 align="center" style={{ color: 'rgb(43, 57, 55)', marginBottom: '40px', fontSize: '2.5rem' }}>
          This Week's Sports Picks
        </h5>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
          <button
            style={selectedSport === 'NBA' ? selectedSportButtonStyle : sportButtonStyle}
            onClick={() => setSetSelectedSport('NBA')}
          >
            NBA
          </button>
          <button
            style={selectedSport === 'EPL' ? selectedSportButtonStyle : sportButtonStyle}
            onClick={() => setSetSelectedSport('EPL')}
          >
            EPL
          </button>
          <button
            style={selectedSport === 'MLS' ? selectedSportButtonStyle : sportButtonStyle}
            onClick={() => setSetSelectedSport('MLS')}
          >
            MLS
          </button>
          <button
            style={selectedSport === 'MLB' ? selectedSportButtonStyle : sportButtonStyle}
            onClick={() => setSetSelectedSport('MLB')}
          >
            MLB
          </button>
        </div>
        {loading ? (
          <p>Loading event details...</p>
        ) : allPicksMade[selectedSport] ? (
          <div align="center">
            <img src={`/HomePage/ballincat.jpg`} alt="All Picks Made" style={{ width: '200px', height: 'auto' }} />
            <p></p>
            <p style={{ fontSize: '1.5rem' }}>You have made all upcoming picks for the {selectedSport}.</p>
            <p style={{ fontSize: '1.5rem' }}>Visit the "History" page to view your picks.</p>
          </div>
        ) : (Object.keys(eventsByDate).length > 0) ? (
          sortDates(Object.keys(eventsByDate)).map((date, index) => {
            const gamesForDate = eventsByDate[date].filter(game => gameVisibility[date]?.[game.game_id]);
            return gamesForDate.length > 0 ? (
              <div key={index} style={{ transition: 'opacity 0.3s, height 0.3s', opacity: 1, overflow: 'hidden' }}>
                <h3 style={{ textAlign: 'center', marginTop: '20px' }}>{formatDate(date)}</h3>
                {gamesForDate.map((event, eventIndex) => (
                  <MatchPick
                    key={eventIndex}
                    homeTeam={event.home_team.toUpperCase()}
                    awayTeam={event.away_team.toUpperCase()}
                    gameid={event.game_id}
                    onPickSelected={(team, gameid) => {
                      setPicks(currentPicks => {
                        const updatedPicks = currentPicks[date] ? currentPicks[date].filter(p => p.gameid !== gameid) : [];
                        if (team) {
                          updatedPicks.push({ gameid, team });
                        }
                        return {
                          ...currentPicks,
                          [date]: updatedPicks,
                        };
                      });
                    }}
                    isEPL={(selectedSport === 'EPL' || selectedSport === 'MLS')}
                    isLoading={loading}
                  />
                ))}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
                  <button
                    style={makePicksButtonStyle}
                    onClick={() => handleMakePicksForDate(date, selectedSport)}
                    disabled={submittingStatus[date]}
                  >
                    {submittingStatus[date] ? 'Submitting...' : 'Make Picks'}
                  </button>
                  {pickFeedback[date] && (
                    <p style={{ marginTop: '6px', color: pickFeedback[date].type === 'success' ? 'green' : 'red', fontWeight: 'bold', fontSize: '0.9rem' }}>
                      {pickFeedback[date].msg}
                    </p>
                  )}
                </div>
              </div>
            ) : null;
          })
        ) : (
          <div align="center" style={{ marginTop: '40px' }}>
            <img src={`/HomePage/ballincat.jpg`} alt="No games available" style={{ width: '200px', height: 'auto' }} />
            <p></p>
            <p style={{ fontSize: '1.5rem' }}>No upcoming {selectedSport} games are currently available.</p>
          </div>
        )}
      </div>
    </BaseLayout>
  );
};

export default HomePage;
